<div class="h-full flex items-center justify-center overflow-y-auto p-2 lg:pl-0">
  <div class="w-full max-w-2xl">

  <!-- Main Card -->
  <div
    class="overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow dark:border-white/10 dark:bg-zinc-950 dark:ring-white/5">
  
    <!-- Top Status Section -->
    <div class="px-6 pb-7 pt-8 text-center sm:px-10 sm:pb-8 sm:pt-10">
  
      <!-- Connection Visual -->
      <div class="flex items-center justify-center">
  
        <!-- Company -->
        <div class="flex flex-col items-center">
          <div
            class="flex h-14 w-14 items-center justify-center rounded-xl border border-zinc-200 bg-zinc-50 shadow-sm dark:border-white/10 dark:bg-zinc-900">
  
            <!-- Building Office Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-7 text-zinc-600 dark:text-zinc-300">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 21h16.5M4.5 21V5.25A2.25 2.25 0 0 1 6.75 3h4.5A2.25 2.25 0 0 1 13.5 5.25V21m0-12h3.75A2.25 2.25 0 0 1 19.5 11.25V21M8.25 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m4.5-3h1.5m-1.5 3h1.5" />
            </svg>
          </div>
  
          <span class="mt-2 max-w-28 truncate text-xs font-medium text-zinc-600 dark:text-zinc-400">
            {{ companyName || 'Your company' }}
          </span>
        </div>
  
        <!-- Connection Line -->
        <div class="mx-3 flex items-center sm:mx-5">
  
          <div
            class="h-px w-10 sm:w-16"
            [ngClass]="isSuccess
              ? 'bg-green-400 dark:bg-green-500'
              : 'bg-zinc-300 dark:bg-zinc-700'">
          </div>
  
          <div
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border"
            [ngClass]="isSuccess
              ? 'border-green-200 bg-green-50 text-green-600 dark:border-green-400/20 dark:bg-green-400/10 dark:text-green-400'
              : 'border-zinc-200 bg-zinc-50 text-zinc-400 dark:border-white/10 dark:bg-zinc-900 dark:text-zinc-500'">
  
            <!-- Link Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.7"
              stroke="currentColor"
              class="size-4">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13.19 8.688a4.5 4.5 0 0 1 1.121 1.121m-4.242 4.242a4.5 4.5 0 0 1-1.121-1.121m.53-5.485 2.121-2.121a4.5 4.5 0 0 1 6.364 6.364l-2.121 2.121m-5.485.53-2.121 2.121a4.5 4.5 0 0 1-6.364-6.364l2.121-2.121" />
            </svg>
          </div>
  
          <div
            class="h-px w-10 sm:w-16"
            [ngClass]="isSuccess
              ? 'bg-green-400 dark:bg-green-500'
              : 'bg-zinc-300 dark:bg-zinc-700'">
          </div>
  
        </div>
  
        <!-- QuickBooks -->
        <div class="flex flex-col items-center">
          <div
            class="flex h-14 w-14 items-center justify-center rounded-xl border border-green-200 bg-green-50 shadow-sm dark:border-green-400/20 dark:bg-green-400/10">
  
            <!-- QB / Finance Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-7 text-green-600 dark:text-green-400">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6v12m-3-9.75A3.75 3.75 0 0 1 12.75 6H14a3.75 3.75 0 0 1 0 7.5h-1.5A3.75 3.75 0 0 0 8.75 17.25H10A3.75 3.75 0 0 0 13.75 13.5" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z" />
            </svg>
          </div>
  
          <span class="mt-2 text-xs font-medium text-zinc-600 dark:text-zinc-400">
            QuickBooks
          </span>
        </div>
  
      </div>
  
      <!-- Status Icon -->
      <div
        class="mx-auto mt-8 flex h-14 w-14 items-center justify-center rounded-full"
        [ngClass]="isSuccess
          ? 'bg-green-100 text-green-600 dark:bg-green-400/10 dark:text-green-400'
          : 'bg-red-100 text-red-600 dark:bg-red-400/10 dark:text-red-400'">
  
        <!-- Success Check -->
        <svg
          *ngIf="isSuccess"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          class="size-7">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m4.5 12.75 6 6 9-13.5" />
        </svg>
  
        <!-- Error X -->
        <svg
          *ngIf="!isSuccess"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          class="size-7">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12" />
        </svg>
  
      </div>
  
      <!-- Heading -->
      <h1 class="mt-4 text-2xl font-semibold tracking-tight text-zinc-900 dark:text-white sm:text-3xl">
        {{ isSuccess ? 'QuickBooks connected successfully' : 'QuickBooks connection failed' }}
      </h1>
  
      <p class="mx-auto mt-2 max-w-lg text-sm leading-6 text-zinc-500 dark:text-zinc-400">
        {{ isSuccess
          ? 'Your company is now connected and ready to work with QuickBooks.'
          : 'We were unable to complete the connection to QuickBooks.' }}
      </p>
  
    </div>
  
    <!-- Details -->
    <div class="border-t border-zinc-950/10 dark:border-white/10">
  
      <!-- Success -->
      <ng-container *ngIf="isSuccess">
  
        <div class="px-6 py-6 sm:px-10">
  
          <!-- Connected Company -->
          <div
            class="flex items-center gap-4 rounded-xl border border-zinc-200 bg-zinc-50/70 p-4 dark:border-white/10 dark:bg-zinc-900/60">
  
            <div
              class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white shadow-sm dark:bg-zinc-800">
  
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-5 text-zinc-600 dark:text-zinc-300">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 21h16.5M4.5 21V5.25A2.25 2.25 0 0 1 6.75 3h4.5A2.25 2.25 0 0 1 13.5 5.25V21m0-12h3.75A2.25 2.25 0 0 1 19.5 11.25V21M8.25 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5" />
              </svg>
  
            </div>
  
            <div class="min-w-0 flex-1">
              <p class="text-xs font-medium uppercase tracking-wide text-zinc-500 dark:text-zinc-500">
                Connected company
              </p>
  
              <p class="mt-0.5 truncate text-sm font-semibold text-zinc-900 dark:text-white">
                {{ companyName || 'Company' }}
              </p>
            </div>
  
            <span class="badge-success shrink-0">
              Connected
            </span>
          </div>
  
          <!-- Next Steps -->
          <div class="mt-7">
            <h2 class="text-sm font-semibold text-zinc-900 dark:text-white">
              You're all set
            </h2>
  
            <p class="mt-1 text-sm text-zinc-500 dark:text-zinc-400">
              You can now manage your QuickBooks data from the company portal.
            </p>
  
            <div class="mt-4 grid gap-3 sm:grid-cols-2">
  
              <!-- Sync -->
              <div
                class="rounded-xl border border-zinc-200 p-4 dark:border-white/10">
  
                <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-zinc-100 dark:bg-zinc-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5 text-zinc-600 dark:text-zinc-300">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.992 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M5.07 4.356A8.25 8.25 0 0 1 18.873 8.06l3.182 3.182m0 0V6.25m0 5.001h-5.001" />
                  </svg>
                </div>
  
                <p class="mt-3 text-sm font-medium text-zinc-900 dark:text-white">
                  Sync your records
                </p>
  
                <p class="mt-1 text-xs leading-5 text-zinc-500 dark:text-zinc-400">
                  Sync customers, vendors, employees, and services with QuickBooks.
                </p>
              </div>
  
              <!-- Transactions -->
              <div
                class="rounded-xl border border-zinc-200 p-4 dark:border-white/10">
  
                <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-zinc-100 dark:bg-zinc-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-5 text-zinc-600 dark:text-zinc-300">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 14.25 11.25 16.5 15 12.75m-3-9.75a9 9 0 1 0 9 9 9 9 0 0 0-9-9Z" />
                  </svg>
                </div>
  
                <p class="mt-3 text-sm font-medium text-zinc-900 dark:text-white">
                  Manage transactions
                </p>
  
                <p class="mt-1 text-xs leading-5 text-zinc-500 dark:text-zinc-400">
                  Create and manage invoices, bills, and related QuickBooks transactions.
                </p>
              </div>
  
            </div>
          </div>
        </div>
  
      </ng-container>
  
      <!-- Error -->
      <ng-container *ngIf="!isSuccess">
  
        <div class="px-6 py-6 sm:px-10">
  
          <div
            class="rounded-xl border border-red-200 bg-red-50/70 p-4 dark:border-red-400/10 dark:bg-red-400/5">
  
            <div class="flex gap-3">
  
              <div
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-600 dark:bg-red-400/10 dark:text-red-400">
  
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.7"
                  stroke="currentColor"
                  class="size-5">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 9v3.75m0 3h.008v.008H12v-.008ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
  
              </div>
  
              <div>
                <p class="text-sm font-semibold text-zinc-900 dark:text-white">
                  Connection could not be completed
                </p>
  
                <p class="mt-1 text-sm leading-6 text-zinc-600 dark:text-zinc-400">
                  {{ message || 'QuickBooks could not complete the connection. Please return to Companies and try attaching the company again.' }}
                </p>
              </div>
  
            </div>
          </div>
  
          <div class="mt-6">
            <h2 class="text-sm font-semibold text-zinc-900 dark:text-white">
              Try again
            </h2>
  
            <p class="mt-1 text-sm leading-6 text-zinc-500 dark:text-zinc-400">
              Return to the Companies page and use the Attach option from the company actions menu.
            </p>
          </div>
  
        </div>
  
      </ng-container>
  
    </div>
  
    <!-- Footer -->
    <div
      class="flex flex-col-reverse gap-3 border-t border-zinc-950/10 px-6 py-5 dark:border-white/10 sm:flex-row sm:items-center sm:justify-end sm:px-10">
  
      <button
        type="button"
        class="btn btn-secondary w-full sm:w-auto sm:min-w-40"
        (click)="onContinue()">
  
        <svg
          *ngIf="isSuccess"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.7"
          stroke="currentColor"
          class="mr-2 size-4">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
  
        <svg
          *ngIf="!isSuccess"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.7"
          stroke="currentColor"
          class="mr-2 size-4">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.75 9.75 4.5 15m0 0 5.25 5.25M4.5 15h10.125a5.625 5.625 0 0 0 0-11.25H13.5" />
        </svg>
  
        {{ isSuccess ? 'Go to companies' : 'Back to companies' }}
      </button>
  
    </div>
  
  </div>
  
  </div> </div>